const ScheduleCell = ({ children, className, noMinWidth = false }) => {
  // first:z-10 keeps the sticky-left "Crews" column above the day cells
  // when the grid scrolls horizontally. Without it, day cells (later in
  // source order with default z-index) render on top of the sticky
  // column — visible bug in the multi-grid Optimizer (#105) when a grid
  // is narrow and the user scrolls the body cells horizontally.
  //
  // min-w reduced from 8.6rem to 7rem (#105 follow-up) so single-grid
  // mode fits on standard ~1280-1366px viewports without horizontal
  // scrolling. Multi-grid still scrolls within each narrow grid when
  // needed; min-width prevents cells from collapsing to unusable sizes.
  //
  // noMinWidth=true removes the min-width entirely — used by single-grid
  // OptimizerGrid so cells can shrink below 7rem when the user widens
  // the RTS sidebar enough that the natural row width would otherwise
  // overflow. Multi-grid keeps min-width so cells remain readable.
  return (
    <div
      className={`${className} ${
        noMinWidth ? "" : "min-w-[7rem]"
      } flex-1 overflow-hidden basis-32 ml-4 first:ml-0 first:sticky first:left-0 first:z-10`}
    >
      {children}
    </div>
  );
};

export default ScheduleCell;
